module.exports = __webpack_public_path__ + "img/home-hero.0390661e.jpg";